import React from 'react'
import ErrorMessage, { ErrorMessageProps } from 'components/ErrorMessage'
import { trackTransactionalError } from 'lib/utils/errors'

interface Props {
  shouldTrack?: boolean
  componentName: string
}

type ErrorComponentProps = Props &
  Omit<ErrorMessageProps, 'title'> & {
    title?: string
  }

class ErrorComponent extends React.Component<ErrorComponentProps> {
  static defaultProps = {
    title: 'Oops',
    shouldTrack: true,
    primaryButton: {
      children: 'Reload',
      onClick: () => window.location.reload()
    }
  }

  componentDidMount() {
    this.trackPotentialError()
  }

  componentDidUpdate() {
    this.trackPotentialError()
  }

  trackPotentialError = () => {
    if (!this.props.shouldTrack) {
      return
    }

    const title = this.props.title

    trackTransactionalError(this.props.componentName, {
      path: 'unknown',
      transactionTitle: title
    })
  }

  render() {
    const { shouldTrack, componentName, ...otherProps } = this.props

    return <ErrorMessage {...(otherProps as ErrorMessageProps)} />
  }
}

export default ErrorComponent
